import Bugsnag from "@bugsnag/js"
import BugsnagPluginVue from "@bugsnag/plugin-vue"
import appConfig from "./constants/appConfig";

// Add here for the errors that need to be supressed
export const SupressedErrors = Object.freeze([]);

export const BugsnagConfig = {
    configure() {
        console.log('Bugsnag loaded')
        Bugsnag.start({
            apiKey: appConfig.bugsnagApiKey,
            plugins: [new BugsnagPluginVue()],
            releaseStage: import.meta.env.VITE_ENV,
            onError: (event) => {
                if (event && event.originalError) {
                    const originalError = event.originalError;

                    if (SupressedErrors.some(suppressedError => originalError instanceof suppressedError)) {
                        return false;
                    }

                    if (originalError.message && originalError.message.includes('Request failed with status code 401')) {
                        return false;
                    }
                }
                return true;
            }
        });
    },
    notifyError(error: unknown) {
        if (error instanceof Error) {
            Bugsnag.notify(error);
        } else {
            Bugsnag.notify(new Error(String(error)));
        }
    }
}